import lodash from 'lodash'
import React, { useEffect, useMemo, useState } from 'react'
import styled from 'styled-components'

import {
  Label,
  useField,
} from '../../../../../../1stlog-ui/src/components/Field'
import { ListGroupItem } from '../../../../../../1stlog-ui/src/components/ListGroup'

const Wrapper = styled(ListGroupItem)``

const CustomerReferenceText = (props) => {
  const { value } = props

  return (
    <Wrapper>
      <Label>{i18n.t('customer_reference', 'Kundenreferenz')}</Label>
      <div>{value}</div>
    </Wrapper>
  )
}

export default CustomerReferenceText
